import { render, staticRenderFns } from "./DivInfoCall.vue?vue&type=template&id=7c6044a6&scoped=true&lang=pug&"
import script from "./DivInfoCall.vue?vue&type=script&lang=js&"
export * from "./DivInfoCall.vue?vue&type=script&lang=js&"
import style0 from "./DivInfoCall.vue?vue&type=style&index=0&id=7c6044a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6044a6",
  null
  
)

export default component.exports